import axios from 'axios'
import constants from '../constants'
import { UserTraining } from '../types'
import { AssignPayload, UserTrainingIds, CertificatePayload, LaunchCoursePayload, TrainingCertificate } from '../views/practice/training/types'

const getUserTrainings = async (customerNumber: string) => {
  const response = await axios.get<UserTraining[]>(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users-training`)
  return response.data
}

const assignTraining = async (customerNumber: string, payload: AssignPayload[]) => {
  const response = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users-training/assign`, { users: payload })
  const data: { message: string, user_training_ids: UserTrainingIds } = response.data

  return data
}

const unassignTraining = async (customerNumber: string, payload: AssignPayload[]) => {
  const response = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users-training/unassign`, { users: payload })
  const data: { message: string, user_training_ids: UserTrainingIds } = response.data

  return data
}

const enrollTraining = async (customerNumber: string, payload: UserTrainingIds) => {
  await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users-training/enroll`, { user_training_ids: payload })
}

const unenrollTraining = async (customerNumber: string, payload: UserTrainingIds) => {
  await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users-training/unenroll`, { user_training_ids: payload })
}

const buildTrainingCompliance = async (customerNumber: string, action: 'assign' | 'unassign') => {
  await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users-training/compliance/${action}`)
}

const launchCourse = async (customerNumber: string, payload: LaunchCoursePayload) => {
  const response = await axios.post<{ url: string }>(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users-training/launch-course`, payload)
  return response.data.url
}

const downloadCertificate = async (customerNumber: string, payload: CertificatePayload) => {
  const response = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users-training/certificate`, payload)
  const certificate: TrainingCertificate | null = response.data

  return certificate
}

export {
  getUserTrainings,
  assignTraining,
  unassignTraining,
  enrollTraining,
  unenrollTraining,
  buildTrainingCompliance,
  launchCourse,
  downloadCertificate,
}
